// extracted by mini-css-extract-plugin
module.exports = {"container":"PopupContainer_container__2NyKW"};